<div class="caption-sub-title" [ngClass]="datas.length > 2 ? 'caption-sub-title-hover' : null">
<div class="elem" *ngFor="let data of datas" >
         <i  *ngIf="data.name" class="fal {{data.icon}}" tooltip="{{data.title|translate:locale.language}}"></i> <span> {{data.name}}</span>
 </div>

<ng-content class="pull-right"></ng-content>


</div>
